import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <p>© {new Date().getFullYear()} ScaleNest. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
